var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"ui-card",class:{hasHeader: _vm.hasHeader, hasContent: _vm.hasContent}},[_c('header',{staticClass:"ui-card_header"},[_vm._t("header"),(_vm.hasHeader && _vm.hasContent)?_c('app-card-line',{staticClass:"m-t-16"}):_vm._e()],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }